var angular = require('angular');
var _module = require('../module');
var _ = require('lodash');
var $ = require('jquery');

require('angular-ui-router');
require('../header');
require('../header-branded');
require('../hero');
require('../starburst');
require('../animations');
require('./affiliate-branding');
require('./search');
require('./options');
require('./price');
require('./sqfeet');
require('./featured-properties');
require('./testimonials');
require('./contact-agent-lo');
require('./latest-videos');
require('./branded-search');
require('../window-height');
require('../mortgage-calculator');
require('../../services/search');
require('../../services/search-filter');
require('../../services/user');
require('../../services/fullscreen-loading');
require('../../services/analytics');
require('../../services/branded-nav');
require('../../services/add-buyer-agent-modal');

_module.requires.push('ui.router');

_module.component('homepage', {
    controllerAs: 'homepage',
    controller: [
        '$log',
        '$scope',
        '$q',
        '$timeout',
        '$filter',
        '$state',
        '$stateParams',
        'Search',
        'SearchFilter',
        '$user',
        '$fsloading',
        '$analytics',
        '$brandedNav',
        '$addBuyerAgentModal',

        function homepageCtrl($log, $scope, $q, $timeout, $filter, $state, $stateParams, Search, SearchFilter, $user, $fsloading, $analytics, $brandedNav, $addBuyerAgentModal) {
            var _this = this;
            var stepIndex = 0;
            var filter = new SearchFilter();

            $log.debug($user);

            if(!$stateParams.preventSearchFilterRedirect && $user.filters && $user.filters.length > 0 && ($stateParams.psffr || '').toLowerCase() !== 'true') {
                $state.go('search');
            }

            this.user = $user;
            this.brandedNav = $brandedNav;
            this.exampleListing = {
                price: 189400,
                state: 'Ca'
            };
            this.steps = [
                'search',

                'price',
                'buyingtimeframe',
                // 'whatsimportant',
                'schools',
                'hometype',
                'bedrooms',
                // 'bathrooms',
                'age',
                'stories',
                'sqfeet',
                'lotsize',
                // 'sellerscontact', // Removed 2018-08-07 by LC
                // 'notifyme', // Removed 2019-06-11 by AB

                'results'
            ];
            this.totalHomesFound = 0;
            this.heroImage = '/images/hero/homepage.jpg';
            this.currentStep = this.steps[stepIndex];
            this.options = {
                schools: {
                    title: 'How important are good schools?',
                    options: [
                        {
                            icon: '/images/homepage/options/schools-very@2x.png',
                            value: 'very'
                        },
                        {
                            icon: '/images/homepage/options/schools-somewhat@2x.png',
                            value: 'somewhat'
                        },
                        {
                            icon: '/images/homepage/options/schools-notsomuch@2x.png',
                            value: 'not so much'
                        }
                    ]
                },
                hometype: {
                    title: 'Which type of home?',
                    options: [
                        {
                            icon: '/images/homepage/options/hometype-detached@2x.png',
                            value: 'detached'
                        },
                        {
                            icon: '/images/homepage/options/hometype-attached@2x.png',
                            value: 'attached'
                        },
                        {
                            icon: '/images/homepage/options/hometype-either@2x.png',
                            value: null
                        }
                    ]
                },
                bedrooms: {
                    title: 'How many bedrooms?',
                    options: [
                        {
                            icon: '/images/homepage/options/bedrooms-studio-single@2x.png',
                            value: '1'
                        },
                        // {
                        //     icon: '/images/homepage/options/bedrooms-23@2x.png',
                        //     value: '2-3'
                        // },
                        {
                            icon: '/images/homepage/options/bedrooms-2@2x.png',
                            value: '2'
                        },
                        {
                            icon: '/images/homepage/options/bedrooms-3@2x.png',
                            value: '3'
                        },
                        {
                            icon: '/images/homepage/options/bedrooms-4plus@2x.png',
                            value: '4+'
                        }
                        // {
                        //     icon: '/images/homepage/options/bedrooms-any@2x.png',
                        //     value: null
                        // }
                    ]
                },
                stories: {
                    title: 'How many stories?',
                    options: [
                        {
                            icon: '/images/homepage/options/stories-1@2x.png',
                            value: '1'
                        },
                        {
                            icon: '/images/homepage/options/stories-2@2x.png',
                            value: '2+'
                        },
                        {
                            icon: '/images/homepage/options/stories-either@2x.png',
                            value: null
                        }
                    ]
                },
                lotsize: {
                    title: 'What size lot (yard)?',
                    options: [
                        {
                            icon: '/images/homepage/options/lotsize-small@2x.png',
                            value: 'small'
                        },
                        {
                            icon: '/images/homepage/options/lotsize-medium@2x.png',
                            value: 'medium'
                        },
                        {
                            icon: '/images/homepage/options/lotsize-large@2x.png',
                            value: 'large'
                        },
                        {
                            icon: '/images/homepage/options/lotsize-any@2x.png',
                            value: null
                        }
                    ]
                },
                buyingtimeframe: {
                    title: 'When do you want to buy?',
                    options: [
                        {
                            icon: '/images/homepage/options/buyingtimeframe-0-60-days@2x.png',
                            value: '0-60 days'
                        },
                        {
                            icon: '/images/homepage/options/buyingtimeframe-0-120-days@2x.png',
                            value: '0-120 days'
                        },
                        {
                            icon: '/images/homepage/options/buyingtimeframe-0-180-days@2x.png',
                            value: '0-180 days'
                        },
                        {
                            icon: '/images/homepage/options/buyingtimeframe-someday@2x.png',
                            value: 'someday'
                        }
                    ]
                },
                sellerscontact: {
                    title: 'Sellers can contact me:',
                    options: [
                        {
                            icon: '/images/homepage/options/sellerscontact-my-loan-officer-or-agent@2x.png',
                            value: 'my loan officer or agent'
                        },
                        {
                            icon: '/images/homepage/options/sellerscontact-anyone@2x.png',
                            value: 'anyone'
                        }
                    ]
                },
                notifyme: {
                    title: 'Please notify me when there are:',
                    options: [
                        {
                            icon: '/images/homepage/options/notify-me-when-only-off-market@2x.png',
                            value: 'off market only'
                        },
                        {
                            icon: '/images/homepage/options/notify-me-when-anything@2x.png',
                            value: 'anything'
                        }
                    ]
                },
                whatsimportant: {
                    title: "What's most important to you?",
                    options: [
                        {
                            icon: '/images/homepage/options/whatsimportant-walkability@2x.png',
                            value: 'walkability'
                        },
                        {
                            icon: '/images/homepage/options/whatsimportant-restaurants@2x.png',
                            value: 'restaurants'
                        },
                        {
                            icon: '/images/homepage/options/whatsimportant-outdoors@2x.png',
                            value: 'outdoors'
                        },
                        {
                            icon: '/images/homepage/options/whatsimportant-all@2x.png',
                            value: null
                        }
                    ]
                },
                age: {
                    title: 'Age of home?',
                    options: [
                        {
                            icon: '/images/homepage/options/age-less-10@2x.png',
                            value: '< 10'
                        },
                        {
                            icon: '/images/homepage/options/age-10-50@2x.png',
                            value: '10-50'
                        },
                        {
                            icon: '/images/homepage/options/age-50plus@2x.png',
                            value: '50+'
                        },
                        {
                            icon: '/images/homepage/options/age-any@2x.png',
                            value: null
                        }
                    ]
                },
                bathrooms: {
                    title: 'How many bathrooms?',
                    options: [
                        {
                            icon: '/images/homepage/options/baths-1-2@2x.png',
                            value: '1-2'
                        },
                        {
                            icon: '/images/homepage/options/baths-3-4@2x.png',
                            value: '3-4'
                        },
                        {
                            icon: '/images/homepage/options/baths-5plus@2x.png',
                            value: '5+'
                        },
                        {
                            icon: '/images/homepage/options/baths-any@2x.png',
                            value: null
                        }
                    ]
                }
            };
            this.branded = _.get($user, 'affiliate.benoit_partner.role.acls.nestme.allow_branded_pages', false) || _.get($user, 'affiliate.role.acls.nestme.allow_branded_pages', false);
            this.agentBranded = _.get($user, 'affiliate.benoit_partner.role.acls.nestme.allow_branded_pages', false);
            this.vendorBranded = _.get($user, 'affiliate.role.acls.nestme.allow_branded_pages', false);
            this.usingCustomBackground = false;


            // Functions
            this.getHeroHeightOffset = function getHeroHeightOffset() {
                return _this.branded ? 0 : -(window.innerHeight * 0.25);
            };

            this.onSearch = function onSearch(value) {
                $log.debug('on search:', value);

                $analytics.eventTrack('Listing Search Submit', {
                    Source: 'Home Page',
                    'Search Term': value
                });

                _this.currentStep = 'searching';
                filter.name = 'My ' + value + ' Homes';
                filter.search_term = value;

                new Search(value).getListings()
                .then(function (response) {
                    if(response.listings.length === 1) {
                        var listing = response.listings[0];
                        $state.go('viewlisting', { listingId: listing.id, address: $filter('slug')(listing.address) });
                    } else {
                        nextStep(1);
                    }
                })
                .catch(function (err) {
                    $log.error('onSearch -> Search().getListings -> Error', err);
                    nextStep(1);
                });

            };

            this.onSelect = function onSelect(value) {
                $log.debug('on ' + _this.steps[stepIndex] + ' select', value);

                if(!(typeof value == 'undefined' || value === null)) {
                    filter.addFilter(_this.steps[stepIndex], value);
                    _this.totalHomesFound = filter.filtered_count <= 10 ? '<10' : filter.filtered_count;
                }

                nextStep();
            };

            this.onGotoResults = function onGotoResults() {
                $log.debug('onGotoResults');

                $analytics.eventTrack('No Thanks Show Me Homes Button Click', {
                    Source: _this.steps[stepIndex],
                    'Steps Completed': stepIndex - 1
                });

                saveFilter();
            };

            this.makeMobile = function makeMobile(url) {
                return url.replace(/(@2x\.)/gi, '-mobile$1');
            };

            this.getHeroImage = function getHeroImage() {
                if(_.get($user, 'affiliate.role.acls.nestme.allow_branded_pages') && _.get($user, 'affiliate.customizations.branded_background_image')) {
                    _this.usingCustomBackground = true;
                    return _.get($user, 'affiliate.customizations.branded_background_image');
                }

                if(window.innerWidth >= 600) {
                    return '/images/hero/homepage.jpg';
                } else {
                    return '/images/hero/homepage-mobile.jpg';
                }
            };

            this.prevStep = prevStep;

            function nextStep(step) {
                if(step !== undefined) stepIndex = step - 1;

                if(_this.steps[stepIndex + 1] === _this.steps[_this.steps.length - 1]) {
                    return saveFilter();
                }

                _this.currentStep = _this.steps[++stepIndex];
            }

            function prevStep() {
                _this.currentStep = _this.steps[--stepIndex];
            }

            function saveFilter() {
                var start;

                checkIfWeHaveBuyerAgent()
                .then(function () {
                    $fsloading.show();

                    $log.debug('Started saving the filter');
                    start = new Date().getTime();
                    filter.ownerId = $user.id;

                    return filter.save();

                })
                .then(function () {
                    $user.addSearchFilter(filter, true);
                    $log.debug('Filter saved', (new Date().getTime() - start) / 1000);
                    $state.go('search');
                })
                .catch(function saveFilterError(err) {
                    $log.error(err);
                })
                .finally(function saveFilterFinally() {
                    $fsloading.hide();
                });
            }

            function checkIfWeHaveBuyerAgent() {
                if(
                    !$user.buyer_agent &&
                    $user.affiliate &&
                    $user.affiliate.vendorId &&
                    !_.get($user, 'buyer_agent.verified')
                ) {
                    return $addBuyerAgentModal({
                        id: $user.id,
                        showConfirmationModal: false,
                        analyticsEventNameSubmit: 'Nest Buyer Agent Info Submit',
                        analyticsEventDataSubmit: {
                            Source: 'Nest Wizard'
                        }
                    })
                    .result
                    .catch(function () {
                        $analytics.eventTrack('Nest Buyer Agent Info Skip', {
                            Source: 'Nest Wizard'
                        });

                        return null;
                    });
                } else {
                    return $q.when(null);
                }
            }
        }
    ],
    template: require('./index.html')
});
